import React, { useState } from 'react';
import PremisesDetail from './PremiseDetail';
import { Space, Col, Row, Pagination } from 'antd';

const PremisesList = ({ premises, isFromSearch }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6;

    // Calculate the index range for the current page
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    // Get the current page items
    const currentItems = premises.slice(startIndex, endIndex);
    const totalItems = premises.length;

    const onChange = (page) => {
        setCurrentPage(page);
    }

    return (
        <>
            <Row style={{ marginTop: "10px" }} >
                <Col span={24}>
                    <Space
                        align="start"
                        size={[8, 16]} wrap
                        style={{
                            display: 'flex',
                        }}
                    >
                        {currentItems.map((premise, index) => (
                            <PremisesDetail key={premise.Id} premises={premise} isSearchResult={isFromSearch} index={(currentPage - 1) * 6 + index + 1} />
                        ))}
                    </Space>

                </Col>
            </Row>
            {totalItems > itemsPerPage && (
                <Row style={{ marginTop: "10px" }} >
                    <Col span={24}>
                        <Pagination defaultCurrent={1} onChange={onChange} total={premises.length} defaultPageSize={itemsPerPage} />
                    </Col>
                </Row>
            )}
        </>

    );
};

export default PremisesList;

